export const selectIsMobileCategotiesOpened = (state) => state.layout.isMobileCategotiesOpened;

export const selectIsPageReadyToDisplay = (state) => state.layout.isPageReadyToDisplay;

export const selectIsFirstPageLoaded = (state) => state.layout.isFirstPageLoaded;

export const selectIsMobile = (state) => state.layout.isMobileResolution;

export const selectIsTablet = (state) => state.layout.isTabletResolution;

export const selectIsSmallTablet = (state) => state.layout.isSmallTabletResolution;

export const selectIsDesktop = (state) => state.layout.isDesktopResolution;
